/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Loud_Duck_ClipInputs */

const en_teal_loud_duck_clip = /** @type {(inputs: Teal_Loud_Duck_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to reactivate survey token`)
};

const de_teal_loud_duck_clip = /** @type {(inputs: Teal_Loud_Duck_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktivierung des Tokens fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed to reactivate survey token" |
*
* @param {Teal_Loud_Duck_ClipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_loud_duck_clip = /** @type {((inputs?: Teal_Loud_Duck_ClipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Loud_Duck_ClipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_loud_duck_clip(inputs)
	return de_teal_loud_duck_clip(inputs)
});